import { strings } from "@/constants";
import type { UserInterface } from "@/interfaces";

const detailRowClass = `
    flex
    items-center
    justify-between
    gap-2
    px-4
    py-3
    sm:gap-4
    sm:px-6
    sm:py-4
`;

export const ProfileDetails = ({
    isAdmin,
    roleLabel,
    user,
}: {
    isAdmin: boolean,
    roleLabel: string,
    user: UserInterface | null,
}) => (
    <dl className="divide-y divide-gray-100">
        <div className={detailRowClass}>
            <dt className="text-sm text-text-secondary">{strings.profile.nameLabel}</dt>
            <dd className="text-sm font-medium text-text-primary">{user?.name || strings.profile.notAvailable}</dd>
        </div>
        <div className={detailRowClass}>
            <dt className="text-sm text-text-secondary">{strings.profile.emailLabel}</dt>
            <dd
                className="
                    truncate
                    text-sm
                    font-medium
                    text-text-primary
                "
            >
                {user?.email || strings.profile.notAvailable}
            </dd>
        </div>
        <div className={detailRowClass}>
            <dt className="text-sm text-text-secondary">{strings.profile.roleLabel}</dt>
            <dd className="text-sm font-medium text-text-primary">{roleLabel}</dd>
        </div>
        {!isAdmin && (
            <>
                <div className={detailRowClass}>
                    <dt className="text-sm text-text-secondary">{strings.profile.companyLabel}</dt>
                    <dd className="text-sm font-medium text-text-primary">{user?.companyName || strings.profile.notAvailable}</dd>
                </div>
                <div className={detailRowClass}>
                    <dt className="text-sm text-text-secondary">{strings.profile.phoneLabel}</dt>
                    <dd className="text-sm font-medium text-text-primary">{user?.phone || strings.profile.notAvailable}</dd>
                </div>
            </>
        )}
    </dl>
);
